.messages {
    padding: 0;
    margin: 0;
    list-style: none;
}

.error,
.warning,
.info {
    padding: 10px 0;
    margin: 0;
    display: flex;
    align-items: center;
}

.error {
    color: var(--color-error);
}
.warning {
    color: var(--color-warning);
}
.info {
    color: var(--color-info);
}

es-icon {
    margin-right: 6px;
}
